const thirdPartyErrorMessages: Array<String> = [
    'Script error.',
    'Can\'t find variable: _AutofillCallbackHandler',
    'null is not an object (evaluating \'o.parentNode.nodeType\')',
    'Failed to unregister Service Worker',
];

export default thirdPartyErrorMessages;
